import { l as r } from "./length-of-array-like.js";
var a = function a(_a, e) {
  for (var o = r(_a), n = new e(o), t = 0; t < o; t++) n[t] = _a[o - t - 1];
  return n;
};
export { a };